export default {"src":"/_next/static/media/404.f39323d2.svg","height":656,"width":1200,"blurWidth":0,"blurHeight":0};